import { useMemo } from "react"
import { Tooltip } from "antd"
import {
  getStatusDefinition,
  STOCK_STATUSES,
} from "../../components/BasicTable/StatusPillDefinitions"

const StockDetailTooltip = ({ count }) => {
  return (
    <span className="">
      {count.map((stock_count, i) => (
        <span key={stock_count.status}>
          {getStatusDefinition(stock_count.status, STOCK_STATUSES).label}: {stock_count.count}
          <br></br>
        </span>
      ))}
    </span>
  )
}

export const TotalCountContainer = ({ total, countByStatus, useStockOnlyFromConfirmedReplenishments }) => {
  const filteredCountByStatus = useMemo(() => {
    if (!countByStatus) return []

    const countStatusesToHide = []

    if (useStockOnlyFromConfirmedReplenishments === true) {
      countStatusesToHide.push("ACTIVE")
    } else {
      countStatusesToHide.push("ACTIVE_NOT_EXTERNALLY_CONFIRMED", "ACTIVE_EXTERNALLY_CONFIRMED")
    }

    return countByStatus.filter(stock_count => !countStatusesToHide.includes(stock_count.status))
  }, [countByStatus, useStockOnlyFromConfirmedReplenishments])

  return (
    <div className="w-full">
          <span className="text-lg">
            Total: {total}
          </span>
          <br></br>
        <StockDetailTooltip count={filteredCountByStatus} />
        
    </div>
  )
}
